import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";

import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import Select from "../common/form/select";
import { setModoTela, initForm, setFiltro, getLista, salvarContrato, excluirContrato, buscarArquivoContrato, getListaGrupoContratoAluguel } from "./contratoAluguelActions";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { adicionarBloqueioUsuarioImplantacao } from "../utils/adicionarBloqueioUsuarioImplantacao";
import { getUcValidarUsuarioImplantacao } from "../cliente/clienteActions";
import NewTr from "../common/table/newTr";
import Td from "../common/table/td";
import TBody from "../common/table/tBody";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Th from "../common/table/th";
import ButtonTable from "../common/table/buttonTable";
import FormatUtils from "../common/formatUtils/FormatUtils";

import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { ModalGrupoContratoAluguelForm } from "./components/ModalGrupoContratoAluguelForm";
import { useEffect } from "react";
import { useState } from "react";
import { ContratoAluguelHistoricoForm } from "./contratoAluguelHistoricoForm";

function ContratoAluguelForm(props) {
    const [state, setState] = useState({
        contrato: null,
        exibirModalGrupoContratoAluguel: false,
    });

    useEffect(() => {
        props.getUcValidarUsuarioImplantacao();
        props.setFiltro({
            ...props.filtro,
            id_cliente: null,
            id_unidade_consumidora: null,
        });
        props.getLista();
        if (props.formularioValues.id_cliente) {
            props.getListaGrupoContratoAluguel({ idCliente: props.formularioValues.id_cliente });
        }
    }, []);

    const readOnly = !!(props.excluir || props.visualizacao);

    let listaUCsGeradorasAtivas = props.listaUnidadeConsumidora //não lista geradoras que também são remotas, pq se elas ja dependem de outra, devem ter usado 100 da sua própria produção
        .filter((uc) => {
            const clienteValidado = !props.formularioValues.id_cliente || uc.id_cliente == props.formularioValues.id_cliente;
            return clienteValidado && uc.geracao && !uc.id_unidade_geradora && !uc.data_desligamento;
        });

    listaUCsGeradorasAtivas.unshift({ id: 0, valor: "Usina Externa - Fonte Não Informada" });

    const listaUCsRemotasAtivas = props.listaUnidadeConsumidora //não lista geradoras que também são remotas, pq se elas ja dependem de outra, devem ter usado 100 da sua própria produção
        .filter((uc) => {
            const diferenteDaSelecionada =
                !props.formularioValues.ids_unidades_remotas.length || !props.formularioValues.ids_unidades_remotas.find((unidade) => unidade.value == uc.id);

            const clienteValidado = !props.formularioValues.id_cliente || uc.id_cliente == props.formularioValues.id_cliente;
            return diferenteDaSelecionada && clienteValidado && (uc.id_unidade_geradora || uc.geradora_externa) && !uc.data_desligamento;
        });

    function handleCloseModalGrupo() {
        props.getListaGrupoContratoAluguel({ idCliente: props.formularioValues.id_cliente });
        setState({ ...state, exibirModalGrupoContratoAluguel: false });
    }


    return (
        <ContentCard>
            {state.exibirModalGrupoContratoAluguel && (
                <ModalGrupoContratoAluguelForm
                    idCliente={props.formularioValues.id_cliente}
                    handleClose={handleCloseModalGrupo}
                    setIdGrupoContratoAluguel={(id_grupo_contrato_aluguel) => {
                        setState({ ...state, contrato: { ...state.contrato, id_grupo_contrato_aluguel } });
                    }}
                />
            )}
            <Form event={props.handleSubmit}>
                <ContentCardBody>
                    <Row>
                        <Field
                            name="id_cliente"
                            component={Select}
                            options={props.listaCliente}
                            label="Cliente"
                            cols="12 12 12 12"
                            placeholder="Selecione o cliente"
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name="id_unidade_geradora"
                            component={Select}
                            options={listaUCsGeradorasAtivas}
                            label="Unidade Geradora"
                            cols="12 12 12 12"
                            placeholder="Selecione a unidade geradora"
                            readOnly={readOnly}
                        />
                    </Row>
                    <Row>
                        <Field
                            name="ids_unidades_remotas"
                            component={Select}
                            options={listaUCsRemotasAtivas}
                            label="Unidades Remotas"
                            cols="12 12 12 12"
                            placeholder="Selecione as UCs remotas"
                            isMulti={true}
                        />
                    </Row>
                </ContentCardBody>
                <ContentCardBody>
                    <Row alignCenter style={{ marginBottom: 30 }}>
                        <Grid cols="6 6 4 3">
                            {props.excluir ? (
                                <Button text="Excluir" submit type={"danger"} icon={"fa fa-trash"} disabled={props.visualizacao} />
                            ) : (
                                <Button text={"Salvar"} submit type={"success"} icon={"fa fa-check"} disabled={props.visualizacao} />
                            )}
                        </Grid>
                        <Grid cols="6 6 4 3">
                            <Button
                                text="Voltar"
                                type={"warning"}
                                icon={"fa fa-chevron-left"}
                                event={() => {
                                    props.getLista();
                                    props.setModoTela("lista");
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardBody>
            </Form>

            {!!props.formularioValues.id && (
                <ContentCardBody>
                    {state.contrato ? (
                        <ContratoAluguelHistoricoForm
                            contrato={state.contrato}
                            handleContratoForm={(novosValores) => setState((prev) => ({ ...prev, contrato: { ...prev.contrato, ...novosValores } }))}
                            listaTipoCustoGestaoContratoAluguel={props.listaTipoCustoGestaoContratoAluguel}
                            listaGrupoContratoAluguel={props.listaGrupoContratoAluguel.filter((c) => c.id_cliente == props.formularioValues.id_cliente)}
                            handleSubmitContrato={() =>
                                props.salvarContrato({
                                    formularioValues: props.formularioValues,
                                    registro: { ...state.contrato, id_contrato_aluguel: props.formularioValues.id },
                                    callback: () => setState({ ...state, contrato: null }),
                                })
                            }
                            handleCloseContratoForm={() => setState({ ...state, contrato: null })}
                            handleOpenModalGrupoContratoAluguelForm={() => setState({ ...state, exibirModalGrupoContratoAluguel: true })}
                        />
                    ) : (
                        <Row>
                            <Grid cols="12 12 4 3">
                                <Button
                                    style={{ margin: 0 }}
                                    text={"Adicionar Contrato"}
                                    type={"primary"}
                                    icon={"fa fa-plus"}
                                    solid={true}
                                    disabled={readOnly}
                                    event={() => {
                                        const novoContrato = {
                                            id_temporario: props.formularioValues.contratos.length,
                                            id_tipo_custo_gestao_contrato_aluguel: 1,
                                            assume_custo_fatura_usina_geradora: false,
                                        };
                                        setState({ ...state, contrato: { ...novoContrato } });
                                    }}
                                />
                            </Grid>
                        </Row>
                    )}
                    <ContentCardBody>
                        <Table maxHeight="40vh" responsive>
                            <THead>
                                <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                    <Th alignCenter={true} sticky>
                                        Status
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Tipo de Análise
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Competência Inícial da Vigência
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Competência Final da Vigência
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Valor Mensal do Aluguel (R$)
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Qtd. de Energia Contratada Anual (kWh)
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Custo de Gestão do Contrato de Aluguel
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Arquivo do Contrato
                                    </Th>
                                </NewTr>
                            </THead>
                            <TBody>
                                {props.formularioValues.contratos.map((item) => {
                                    const itemForm = {
                                        ...item,
                                        competencia_inicio_vigencia: FormatUtils.formatarCompetenciaTela(item.competencia_inicio_vigencia) || null,
                                        competencia_fim_vigencia: FormatUtils.formatarCompetenciaTela(item.competencia_fim_vigencia) || null,
                                        valor_mensal_aluguel: FormatUtils.formatarValorTela(item.valor_mensal_aluguel) || null,
                                        quantidade_energia_contratada_anual: FormatUtils.formatarValorTela(item.quantidade_energia_contratada_anual) || null,
                                        valor_custo_gestao_contrato_aluguel: FormatUtils.formatarValorTela(item.valor_custo_gestao_contrato_aluguel) || null,
                                        percentual_custo_gestao_contrato_aluguel: FormatUtils.formatarValorTela(item.percentual_custo_gestao_contrato_aluguel) || null,
                                    };

                                    const CORES = {
                                        Encerrado: { backgroundColorTr: "#ff5165", backgroundColorTd: "#ff8b99" },
                                        Vigente: { backgroundColorTr: "#32ffad", backgroundColorTd: "#82ffcd" },
                                        Agendado: { backgroundColorTr: "#53a3ff", backgroundColorTd: "#73d4fc" },
                                        Expirado: { backgroundColorTr: "#ffa500", backgroundColorTd: "#ffdab9" },
                                        Indefinido: { backgroundColorTr: "#d3d3d3", backgroundColorTd: "#f0f0f0" },
                                    };

                                    const { backgroundColorTr, backgroundColorTd } = CORES[item.status];

                                    const botoes = [
                                        {
                                            type: "primary",
                                            icon: "fas fa-eye",
                                            disabled: readOnly,
                                            event: () => setState({ ...state, contrato: { ...itemForm, readOnly: true } }),
                                        },
                                        {
                                            type: "warning",
                                            icon: "fas fa-pencil-alt",
                                            disabled: readOnly || item.encerrado,
                                            event: () => setState({ ...state, contrato: { ...itemForm } }),
                                        },
                                        {
                                            type: "danger",
                                            icon: "fas fa-trash-alt",
                                            disabled: readOnly || item.encerrado,
                                            event: () =>
                                                props.excluirContrato({
                                                    formularioValues: props.formularioValues,
                                                    id_contrato_aluguel: itemForm.id_contrato_aluguel,
                                                    id: itemForm.id,
                                                }),
                                        },
                                    ];

                                    const tipoCusto = props.listaTipoCustoGestaoContratoAluguel.find((tipo) => tipo.id === item.id_tipo_custo_gestao_contrato_aluguel) || {};

                                    const custoGestao = (
                                        <div title={tipoCusto.descricao}>
                                            {tipoCusto.id === 1 && <div>Sem custo de gestão</div>}
                                            {tipoCusto.id === 2 && <div>R$ {adicionarPontosMilhar(item.valor_custo_gestao_contrato_aluguel)} fixo mensal</div>}
                                            {tipoCusto.id === 3 && <div>R$ {adicionarPontosMilhar(item.valor_custo_gestao_contrato_aluguel)}/kWh</div>}
                                            {tipoCusto.id === 4 && <div>{adicionarPontosMilhar(item.percentual_custo_gestao_contrato_aluguel)}% sobre a economia</div>}
                                        </div>
                                    );

                                    return (
                                        <NewTr key={item.id} backgroundColorTd={backgroundColorTd} backgroundColorTr={backgroundColorTr} botoes={botoes}>
                                            <Td alignCenter>{item.status}</Td>
                                            <Td
                                                alignCenter
                                                backgroundColor={item.id_grupo_contrato_aluguel ? "#4169e1" : "#fffbb3"}
                                                color={item.id_grupo_contrato_aluguel ? "#ffffff" : "#000000"}
                                            >
                                                {item.id_grupo_contrato_aluguel ? (
                                                    <div>
                                                        <div>Compartilhada</div>
                                                        <div>
                                                            (Grupo <b className="ml-1">{item.nome_grupo_contrato_aluguel}</b>)
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>Simples</div>
                                                )}
                                            </Td>
                                            <Td alignCenter>{FormatUtils.formatarCompetenciaTela(item.competencia_inicio_vigencia)}</Td>
                                            <Td alignCenter>{FormatUtils.formatarCompetenciaTela(item.competencia_fim_vigencia)}</Td>
                                            <Td alignCenter>{adicionarPontosMilhar(item.valor_mensal_aluguel)}</Td>
                                            <Td alignCenter>{adicionarPontosMilhar(item.quantidade_energia_contratada_anual)}</Td>
                                            <Td alignCenter>{custoGestao}</Td>
                                            <Td alignCenter>
                                                {item.arquivo_contrato ? (
                                                    <ButtonTable
                                                        visible={true}
                                                        type={"primary"}
                                                        icon={"fa fa-file"}
                                                        event={() => {
                                                            props.buscarArquivoContrato({
                                                                id: item.id,
                                                                nome: `Contrato de Aluguel de Usina`,
                                                            });
                                                            props.setArquivoPDF();
                                                        }}
                                                    />
                                                ) : null}
                                            </Td>
                                        </NewTr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    </ContentCardBody>
                </ContentCardBody>
            )}
        </ContentCard>
    );
}

const ContratoAluguelFormRedux = reduxForm({ form: "contratoAluguelForm", destroyOnUnmount: false })(ContratoAluguelForm);
const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    formularioValues: getFormValues("contratoAluguelForm")(state),
    registro: state.contratoAluguel.registro,
    listaCliente: state.contratoAluguel.listaCliente,
    listaUnidadeConsumidora: state.contratoAluguel.listaUnidadeConsumidora,
    lista: adicionarBloqueioUsuarioImplantacao(state.auth.usuarioLogado, state.cliente.listaUcValidarUsuarioImplantacao, state.contratoAluguel.lista),
    listaMeses: state.contratoAluguel.listaMeses,
    listaGrupoContratoAluguel: state.contratoAluguel.listaGrupoContratoAluguel,
    listaTipoCustoGestaoContratoAluguel: state.contratoAluguel.listaTipoCustoGestaoContratoAluguel,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            getLista,
            salvarContrato,
            excluirContrato,
            setArquivoPDF,
            getUcValidarUsuarioImplantacao,
            getListaGrupoContratoAluguel,
            buscarArquivoContrato,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(ContratoAluguelFormRedux);
